// IndexedDB-backed repository. Uses idb-keyval for ergonomics; we only need
// a single key, so a full key-value store is overkill but cheap.

import { del, get, set } from 'idb-keyval';
import type { AppSnapshot, Repository } from './repository';
import { EMPTY_SNAPSHOT } from './repository';
import { migrate } from './migrations';

const KEY = 'zimatch.snapshot.v1';

export class LocalRepository implements Repository {
  async load(): Promise<AppSnapshot> {
    try {
      const raw = await get(KEY);
      if (!raw) return EMPTY_SNAPSHOT;
      return migrate(raw);
    } catch (err) {
      console.warn('[storage] load failed, falling back to empty snapshot', err);
      return EMPTY_SNAPSHOT;
    }
  }

  async save(snapshot: AppSnapshot): Promise<void> {
    try {
      await set(KEY, snapshot);
    } catch (err) {
      console.warn('[storage] save failed', err);
    }
  }

  async clear(): Promise<void> {
    try {
      await del(KEY);
    } catch (err) {
      console.warn('[storage] clear failed', err);
    }
  }
}

export const localRepository = new LocalRepository();
